import * as React from 'react';

import { SUGGESTIONS_LOADER_TEST_ID } from '../../constants';
import style from './Loader.scss';

export const Loader: React.FC = () => {
  return (
    <div className={style.root} data-testid={SUGGESTIONS_LOADER_TEST_ID}>
      <svg viewBox="0 0 50 50" className={style.spinner}>
        <circle
          className={style.circle}
          cx="25"
          cy="25"
          r="20"
          fill="none"
          strokeWidth="2"
        />
      </svg>
    </div>
  );
};
